export ajax from './ajax';
export autoQuery from './autoQuery';
export clickOnEnter from './clickOnEnter';
export confirm from './confirm';
export cookieValue from './cookieValue';
export datepicker from './datepicker';
export dispatchAction from './dispatchAction';
export lazyImage from './lazyImage';
export notify from './notify';
export pagination from './pagination';
// export select2 from './select2';
export showRelated from './showRelated';
export switcher from './switcher';
export tooltip from './tooltip';
export trigger from './trigger';
export autocomplete from './autocomplete';


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/index.js